<template>
  <th
    scope="col"
    :style="headerStyle"
    :colspan="length"
    v-if="department"
  >
    {{ department.name }}
  </th>
</template>

<script>
import colors from '@/lib/colors'

export default {
  name: 'department-header',
  props: {
    length: {
      type: Number,
      default: 1
    },
    department: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    headerStyle () {
      return {
        'border-left-style': 'solid',
        'border-left-width': '1px',
        'border-left-color': this.department.color,
        'background-color': colors.hexToRGBa(this.department.color, 0.2)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

th {
  position: sticky;
  top: 0;
}
</style>
